import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZUpdateSiteApiResponse = z.object({
  id: z.string(),
  siteName: z.string(),
  description: z.string()
})

export interface UpdateSitePutRequest {
  id: string
  siteName: string
  description: string | null
  install_date?: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZUpdateSiteApiResponse,
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type UpdateSiteApiResponse = z.infer<typeof ZUpdateSiteApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function updateSite (
  updateSitePutRequest: UpdateSitePutRequest,
  onSuccess: (successResponse: UpdateSiteApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/sites'
  interceptedAxios
    .put(url, updateSitePutRequest, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        // istanbul ignore else
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
